import * as types from './types'
import {
  APP_BUSINESS_PARTNER_ROLE_PNC,
  APP_BUSINESS_PARTNER_ROLE_PNH,
  APP_BUSINESS_PARTNER_ROLE_APRENDIZ,
  APP_BUSINESS_PARTNER_ROLE_FOCADO,
  APP_BUSINESS_PARTNER_ROLE_PROTAGONISTA,
  APP_BUSINESS_PARTNER_ROLE_CAMPEAO,
  APP_EMPLOYEE_PN_ROLE_ID,
} from '@/constants/auth'
export default {
  [types.USER]: state => {
    return state.user
  },
  [types.TOKEN]: state => {
    return state.token
  },
  [types.IS_HUNTER]: state => {
    return state?.user?.user?.user_role_id == APP_BUSINESS_PARTNER_ROLE_PNH
  },
  [types.IS_PN]: state => {
    return (
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_PNH ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_PNC ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_APRENDIZ ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_FOCADO ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_PROTAGONISTA ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_CAMPEAO ||
      state.user.user_role_id == APP_EMPLOYEE_PN_ROLE_ID
    )
  },
}
